export default __webpack_public_path__ + "static/media/assistance.b8026b2d.svg";